<template>
  <div v-if="state.visible && state.mounted" class="scroll-progress-bar">
    <span class="scroll-progress-bar__animate" :style="computedStyle"/>
  </div>
</template>

<script setup lang="ts">
import {nextTick, onMounted, watch} from 'vue'
import {computed, onNuxtReady, reactive, useWindowScroll, useWindowSize} from '#imports'
import {useChapterStore} from "~/store/chapters";
import {usePageStore} from "~/store/page";
import {onBeforeRouteLeave} from "vue-router";

const chapterStore = useChapterStore()
const pageStore = usePageStore()

type TState = {
  scroll: Number,
  height: Number,
  visible: Boolean,
  mounted: Boolean
}

const state: TState = reactive({
  scroll: 0,
  height: 0,
  visible: false,
  mounted: false
})

const computedStyle = computed(() => {
  const scrollPercentage = (state.scroll !== 0 && state.height !== 0) ? Math.ceil(state.scroll / state.height * 100) : 0
  return {
    width: `${scrollPercentage}%`
  }
})

pageStore.$subscribe(() => {
  state.visible = pageStore.getShowProgressBar
})

onBeforeRouteLeave(() => {
  state.mounted = false
})

onMounted(() => {
  window.setTimeout(() => {
    state.mounted = true
  }, 1000)
})

const showProgressBar = () => {
  const showForPageType = pageStore.getShowProgressBar
  const curPageType = pageStore.getCurrentPage?.collection
  return (showForPageType && curPageType !== 'longread_page')
}

const updateHeight = (windowHeight) => {
  const footer = document.body.querySelector('.footer')
  const footerHeight = (footer) ? footer.getBoundingClientRect().height : 0
  const docHeight = document.body.getBoundingClientRect().height
  state.height = docHeight - footerHeight - windowHeight
}

onMounted(() => {

  state.visible = showProgressBar()

  const windowScroll = useWindowScroll()
  const windowHeight = useWindowSize()

  watch(windowHeight, (newValue) => {
    updateHeight(newValue.height)
  })

  watch(windowScroll, () => {
    state.scroll = windowScroll.scroll
    updateHeight(windowHeight.height)
  })

  if (pageStore.getCurrentPage?.collection === 'longread_page') {
    watch(chapterStore.$state, (newValue) => {

      state.visible = !!(chapterStore.getOpen(pageStore.getCurrentPage.id))

      nextTick(() => {
        updateHeight(windowHeight.height)
      })
    })
  }

  onNuxtReady(() => {
    updateHeight(windowHeight.height)
  })

  updateHeight(windowHeight.height)
})
</script>

<style scoped lang="postcss">
.scroll-progress-bar {
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 40;
  height: 0.25rem;
  width: 100%;

  &__animate {
    display: block;
    height: 100%;
    background-color: var(--color-blue-aqua);
    transition: width 125ms ease;
  }
}
</style>
